"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3511],{

/***/ 31956:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h4": () => (/* binding */ Header)
});

// UNUSED EXPORTS: DOM_EVENT_NAME, hideLoginPopOverEvent, showLoginPopOverEvent

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@growth/use-analytics/dist/growth-use-analytics.esm.js
var growth_use_analytics_esm = __webpack_require__(64993);
// EXTERNAL MODULE: ../../node_modules/@growth/dom-event-emitter/dist/growth-dom-event-emitter.esm.js
var growth_dom_event_emitter_esm = __webpack_require__(63377);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js + 2 modules
var growth_auth_helpers_esm = __webpack_require__(65614);
// EXTERNAL MODULE: ../../node_modules/@growth/data-store/dist/growth-data-store.esm.js
var growth_data_store_esm = __webpack_require__(19485);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/shallow.mjs
var shallow = __webpack_require__(92532);
// EXTERNAL MODULE: ../../node_modules/@growth/pdt-push/dist/growth-pdt-push.esm.js
var growth_pdt_push_esm = __webpack_require__(93488);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/design-system/dist/growth-design-system.esm.js + 4 modules
var growth_design_system_esm = __webpack_require__(66687);
// EXTERNAL MODULE: ../../node_modules/@growth/custom-hooks/useHasMounted/dist/growth-custom-hooks-useHasMounted.esm.js
var growth_custom_hooks_useHasMounted_esm = __webpack_require__(33509);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/dist/dom-events-c707d33c.esm.js


var dom_events_c707d33c_esm_DOM_EVENT_NAME = {
  LOGOUT: 'hr_l',
  LOGOUT_SUCCESS: 'hr_lls',
  START_LOGIN_FLOW: 'hr_slf',
  HEADER_ITEM_CLICK: 'hr_hic',
  IS_NEW_USER: 'hr_inu',
  SHOW_LOGIN_POP_OVER: 'hr_slpo',
  HIDE_LOGIN_POP_OVER: 'hr_hlpo',
  REFRESH_HEADER_DATA: 'hr_rhr',
  LOGIN_SUCCESS: growth_auth_helpers_esm/* LOGIN_SUCCESS */.XP
};



// EXTERNAL MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js + 4 modules
var growth_config_store_browser_esm = __webpack_require__(71956);
// EXTERNAL MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/gi-dweb-auth/dist/growth-gi-dweb-auth.esm.js + 13 modules
var growth_gi_dweb_auth_esm = __webpack_require__(68499);
// EXTERNAL MODULE: ../../node_modules/@growth/modal/dist/growth-modal.esm.js
var growth_modal_esm = __webpack_require__(36374);
// EXTERNAL MODULE: ../../node_modules/@growth/web-analytics/dist/growth-web-analytics.esm.js
var growth_web_analytics_esm = __webpack_require__(22019);
// EXTERNAL MODULE: ../../node_modules/@growth/ssr-utils/dist/growth-ssr-utils.esm.js
var growth_ssr_utils_esm = __webpack_require__(91917);
// EXTERNAL MODULE: ../../node_modules/@growth/analytics-plugin-pdt/dist/growth-analytics-plugin-pdt.esm.js
var growth_analytics_plugin_pdt_esm = __webpack_require__(90305);
// EXTERNAL MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/analytics-plugin-adobe/dist/growth-analytics-plugin-adobe.esm.js
var growth_analytics_plugin_adobe_esm = __webpack_require__(33983);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/dist/growth-dweb-header.esm.js




















function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

var _templateObject$c, _templateObject2$a, _templateObject3$9, _templateObject4$5, _templateObject5$4, _templateObject6$4, _templateObject7$4, _templateObject8$2, _templateObject9$2, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$1, _templateObject14$1, _templateObject15$1;
var bdrAni = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n\t\t0% {\n\t\t\twidth: 0;\n\t\t\tleft: 60%; /* Start from the center */\n\t\t\ttransform: translateX(-50%); /* Center the element horizontally */\n\t\t}\n\t\t50% {\n\t\t\twidth: 100%; /* Expand to the right */\n\t\t\tleft: 0; /* Move to the left edge */\n\t\t\ttransform: translateX(0%);\n\t\t}\n\t\t100% {\n\t\t\twidth: 100%; /* Collapse back to the center */\n\t\t\tleft: 50%; /* End at the center */\n\t\t\ttransform: translateX(-50%);\n\t\t}\n"])));
var HappyNav = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\theight: 100%;\n\toverflow: visible;\n"])));
var ArrowIcon$1 = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteralLoose(["\n  border: solid #717171;\n  width: 9px;\n  height: 9px;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 2px;\n  margin-left: 8px;\n  margin-bottom: ", ";\n  transform: rotate(", ");\n  transition: transform 0.2s ease, margin-bottom 0.2s ease;\n"])), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? '-7px' : '2px';
}, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? '-135deg' : '45deg';
});
var MoreText = styled_components_browser_esm/* default.span */.ZP.span(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteralLoose(["\n\t", ";\n\tcolor: #777777;\n\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var NavLink$1 = styled_components_browser_esm/* default.a */.ZP.a(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-evenly;\n\tcolor: #717171 !important;\n\talign-items: center;\n\tmargin-right: 32px;\n\tposition: relative;\n\theight: 100%;\n\n\t&:visited {\n\t\tcolor: #717171;\n\t}\n\n\t&.active {\n\t\tcolor: #2274e0;\n\t\t&::after {\n\t\t\tposition: absolute;\n\t\t\tbottom: -2px;\n\t\t\tleft: 0;\n\t\t\tcontent: '';\n\t\t\theight: 4px;\n\t\t\twidth: 100%;\n\t\t\tbackground-color: #2274e0;\n\t\t\tborder-radius: 2px;\n\t\t\tanimation: ", " 0.4s 1;\n\t\t}\n\t}\n"])), bdrAni);
var NewLob = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteralLoose(["\n\tborder-radius: 8px;\n\tfont-size: 10px;\n\tpadding: 2px 6px;\n\tcolor: #fff;\n\ttop: -8px;\n\tright: 19px;\n\tbackground: #ff5656;\n\tmargin-left: 5px;\n\tposition: absolute;\n"])));
var NavText = styled_components_browser_esm/* default.span */.ZP.span(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteralLoose(["\n\t", ";\n\tpadding-bottom: 8px;\n\tcolor: ", ";\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2, function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? '#2276E3' : '#777777';
});
var IconWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 34px;\n\t"])));
var NavLinkSvg = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteralLoose(["\n\theight: 24px;\n\twidth: 24px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: contain;\n\tmargin-right: 2px;\n"])));
var NavIcon$1 = styled_components_browser_esm/* default.span */.ZP.span(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteralLoose(["\n\tmargin-right: ", ";\n"])), function (_ref4) {
  var isMore = _ref4.isMore;
  return isMore ? '5px' : '0';
});

// the hidden dropdown menu
var MoreDropdown = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n  display: ", ";\n  flex-direction: column;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  list-style: none;\n  color: #777777;\n  \n  & > li:first-child {\n  border-radius: 8px 8px 0 0;\n  }\n\n  & > li:last-child {\n  border-radius:  0 0 8px 8px;\n  }\n\n"])), function (p) {
  return p.isOpen ? 'flex' : 'none';
});

// trigger that shows the dropdown on hover
var MoreTrigger = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n padding: 33px 0 0 0;\n padding-bottom: 4px;\n  margin-right: 30px;\n  user-select: none;\n    &::before {\n    content: '';\n    position: absolute;\n    top: 17px;               /* adjust to sit above \u201CMore\u201D */\n    left: 19%;\n    width: 4px;\n    height: 4px;\n    background: #ccc;\n    border-radius: 50%;\n    box-shadow: 8px 0 0 #ccc, 16px 0 0 #ccc;\n    transform: translateX(-50%);\n  }\n  &:hover + ", " {\n    display: flex;\n  }\n"])), MoreDropdown);
var HappyNavItem = styled_components_browser_esm/* default.li */.ZP.li(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: transparent;\n\tcursor: pointer;\n\theight: 100%;\n\tposition: relative;\n\toverflow: visible;\n\t", ";\n\n\t&.active,\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n\t/* if this is the \u201CMore\u201D wrapper, don\u2019t underline on hover */\n  ", "\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2, function (_ref5) {
  var isActive = _ref5.isActive;
  return isActive ? '#2274e0' : '#777';
}, function (_ref6) {
  var isMore = _ref6.isMore;
  return isMore && (0,styled_components_browser_esm/* css */.iv)(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteralLoose(["\n\t\tpadding-bottom: 4px;\n     &:hover ", " {\n       display: flex;\n     }\n    "])), MoreDropdown);
});
var DropdownItem = styled_components_browser_esm/* default.li */.ZP.li(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteralLoose(["\n  padding: 8px 12px;\n  white-space: nowrap;\n\n  a {\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    color: inherit;\n  }\n\n  &:hover {\n    background: #E5F3FF;\n  }\n"])));

var isActiveLink = function isActiveLink(navLabel, lobName) {
  if (navLabel && lobName) {
    return navLabel.toLowerCase() === lobName.toLowerCase();
  }
  return false;
};

// const goTribeMembers = [
// 	GOTRIBE_MEMBER_TYPES.star.value,
// 	GOTRIBE_MEMBER_TYPES.superstar.value,
// 	GOTRIBE_MEMBER_TYPES.member.value,
// ];

var getBlackListedUser = function getBlackListedUser(status) {
  return status === 'BLACKLIST';
};
var getControlUser = function getControlUser(status) {
  return status === 'CONTROL';
};
// const isGoTribeMember = (memberType) => goTribeMembers.includes(memberType);

var getUserNameInitials = function getUserNameInitials(name) {
  return name.toString().charAt(0).toUpperCase();
};
var generateDropDownUrl = function generateDropDownUrl(url, navOrigin) {
  return url ? url.replace('{navOrigin}', navOrigin) : '';
};

var NavBar = function NavBar(_ref) {
  var navList = _ref.navList,
    lobName = _ref.lobName;
  var activeClass = (0,react.useCallback)(function (label, lob) {
    return !!isActiveLink(label, lob);
  }, [lobName]);
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
    _useAnalytics.pdt;
    var adobe = _useAnalytics.adobe;
  function navBarGaEvent(item) {
    (0,growth_pdt_push_esm/* pdtPush */.g)('header_click', {
      event_detail: {
        event_type: 'click_event|shopper_click',
        event_value: "" + lobName
      }
    });
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: item.category,
        type: 'itemClick',
        destination: item.url,
        componentName: 'header'
      }
    });
  }
  var BREAKPOINT = 1200;
  var _useState = (0,react.useState)(typeof window !== 'undefined' && window.innerWidth < BREAKPOINT),
    showMore = _useState[0],
    setShowMore = _useState[1];
  var _useState2 = (0,react.useState)(false),
    showMoreDropdown = _useState2[0],
    setShowMoreDropdown = _useState2[1];
  var closeTimer = (0,react.useRef)();
  (0,react.useEffect)(function () {
    var onResize = function onResize() {
      return setShowMore(window.innerWidth < BREAKPOINT);
    };
    window.addEventListener('resize', onResize);
    return function () {
      return window.removeEventListener('resize', onResize);
    };
  }, []);
  var openMenu = (0,react.useCallback)(function () {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setShowMoreDropdown(true);
  }, []);
  var closeMenu = (0,react.useCallback)(function () {
    closeTimer.current = setTimeout(function () {
      return setShowMoreDropdown(false);
    }, 150);
  }, []);

  // last 2 items go into “More”
  var visibleItems = showMore ? navList.slice(0, navList.length - 2) : navList;
  var hiddenItems = showMore ? navList.slice(navList.length - 2) : [];
  return /*#__PURE__*/react.createElement(HappyNav, null, visibleItems.map(function (item) {
    var _item$icon, _item$icon2;
    return /*#__PURE__*/react.createElement(HappyNavItem, {
      key: item.label,
      isActive: activeClass(item.category, lobName)
    }, /*#__PURE__*/react.createElement(NavLink$1, {
      href: item.url,
      target: item.targetBlank ? '_blank' : '_self',
      className: activeClass(item.category, lobName) ? 'active' : '',
      onClick: function onClick() {
        return navBarGaEvent(item);
      }
    }, ((_item$icon = item.icon) == null ? void 0 : _item$icon.type) === 'svg' ? /*#__PURE__*/react.createElement(NavLinkSvg, null, /*#__PURE__*/react.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item == null || (_item$icon2 = item.icon) == null ? void 0 : _item$icon2.source
      }
    })) : /*#__PURE__*/react.createElement(IconWrapper, null, /*#__PURE__*/react.createElement(NavIcon$1, {
      className: "header-sprite nav-icon-" + item.icon
    })), /*#__PURE__*/react.createElement(NavText, {
      isActive: activeClass(item.category, lobName)
    }, item.label), item["new"] && /*#__PURE__*/react.createElement(NewLob, null, "NEW")));
  }), hiddenItems.length > 0 && /*#__PURE__*/react.createElement(HappyNavItem, {
    onMouseEnter: openMenu,
    onMouseLeave: closeMenu,
    isMore: true
  }, /*#__PURE__*/react.createElement(MoreTrigger, null, /*#__PURE__*/react.createElement(MoreText, null, "More"), " ", /*#__PURE__*/react.createElement(ArrowIcon$1, {
    isOpen: showMoreDropdown
  })), /*#__PURE__*/react.createElement(MoreDropdown, {
    isOpen: showMoreDropdown,
    onMouseEnter: openMenu,
    onMouseLeave: closeMenu
  }, hiddenItems.map(function (item) {
    var _item$icon3;
    return /*#__PURE__*/react.createElement(DropdownItem, {
      key: item.label
    }, /*#__PURE__*/react.createElement("a", {
      href: item.url,
      target: item.targetBlank ? '_blank' : '_self',
      onClick: function onClick() {
        return navBarGaEvent(item);
      },
      rel: "noreferrer"
    }, ((_item$icon3 = item.icon) == null ? void 0 : _item$icon3.type) === 'svg' ? /*#__PURE__*/react.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.icon.source
      }
    }) : /*#__PURE__*/react.createElement(NavIcon$1, {
      className: "header-sprite nav-icon-" + item.icon,
      isMore: true
    }), /*#__PURE__*/react.createElement("span", null, item.label)));
  }))));
};

var _templateObject$b, _templateObject2$9;
var LogoLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n    width: 147px;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n\n\n\t.special-logo {\n\t\tmargin-left: -22px;\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: contain;\n\t}\n"])));
var Logo = styled_components_browser_esm/* default.span */.ZP.span(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: inherit;\n\theight: 60px;\n"])));

var HeaderLogo = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var homeURL = _ref.homeURL,
    lobName = _ref.lobName;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var addAnalyticsEvent = function addAnalyticsEvent() {
    (0,growth_pdt_push_esm/* pdtPush */.g)("header_click_logo", {
      event_detail: {
        event_type: "click_event|shopper_click",
        event_value: "" + lobName
      }
    });
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: 'logo',
        destination: homeURL,
        type: 'itemClick',
        componentName: 'header'
      }
    });
  };
  return /*#__PURE__*/react.createElement(LogoLink, {
    href: homeURL,
    onClick: addAnalyticsEvent
  }, /*#__PURE__*/react.createElement(Logo, {
    className: "header-sprite logo gi-logo",
    ref: ref
  }));
});
HeaderLogo.displayName = 'HeaderLogo';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// We use 'W_' as prefix for writing text constants
var W_GENERICS = {
  loginSignup: 'Login / Sign Up',
  loginSignup2: 'Login/Sign Up',
  internetError: 'Internet is not available. Check your connection.',
  apiErrorMsg: 'Some error occurred, please try again.'
};
var GotribeLogoMapping = {
  '1': 'https://go-assets.ibcdn.com/u/GI/images/1714976260429-gotribe1_header2.png',
  '2': 'https://go-assets.ibcdn.com/u/GI/images/1714976278393-gotribe2_header2.png',
  '3': 'https://go-assets.ibcdn.com/u/GI/images/1714976297292-gotribe3_header2.png'
};
var GuestUserGotribeLogo = 'https://go-assets.ibcdn.com/u/GI/images/1721722189530-old-gotribe.png';
var oldProgram = 'GOTRIBE';
var newProgram = 'GOTRIBEV2';
var W_LOGIN_POPOVER_PERSUASION_GENERICS = {
  loginSignup: W_GENERICS.loginSignup2,
  coupon: 'Use Coupon : WELCOME'
};
var W_LOGIN_POPOVER_PERSUASION_FLIGHT = _extends({
  offerTitle: 'FLAT 12% OFF*',
  offerSubTitle: 'on your first Flight booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_HOTEL = _extends({
  offerTitle: 'FLAT 25% OFF* ',
  offerSubTitle: 'on your first Hotel booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_BUS = _extends({
  offerTitle: 'FLAT 10% OFF*',
  offerSubTitle: 'on your first Bus booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_CAB = _extends({
  offerTitle: ' Upto 10% OFF*',
  offerSubTitle: 'on your first Cab booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_TRAIN = _extends({
  offerTitle: 'Zero service fees',
  offerSubTitle: 'on your first Train booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_BANNER_DEFAULT = {
  theme: 'gr-home',
  heading: 'Unlock these benefits',
  subHeading: '',
  benefits: [{
    id: 1,
    heading: 'Earn goCash',
    subHeading: '₹100 on Sign Up & Cashback on Bookings',
    iconClass: 'icGoCash'
  }, {
    id: 2,
    heading: 'Loyalty Benefits',
    subHeading: 'Extra Discounts, Free Seat Selection etc.',
    iconClass: 'icGoTribe'
  }, {
    id: 3,
    heading: 'Exclusive Offers',
    subHeading: 'Daily Steal Deals & Special Discounts',
    iconClass: 'icGiftBlue'
  }],
  offers: W_LOGIN_POPOVER_PERSUASION_FLIGHT
};
_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_HOTEL
});
_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_BUS
});
_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_TRAIN
});
_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_CAB
});
_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_FLIGHT
});
var W_USER_PROFILE_DROPDOWN = function W_USER_PROFILE_DROPDOWN(origin) {
  if (origin === void 0) {
    origin = '';
  }
  return {
    login: {
      label: 'Hey Traveller',
      subLabel: 'Get exclusive deals & Manage your trips',
      ctaText: W_GENERICS.loginSignup2
    },
    view_profile: {
      label: 'View your profile',
      url: origin + "/profile/"
    },
    offers: {
      label: 'Offers',
      subLabel: 'Handpicked best deals',
      icon: 'offers',
      url: origin + "/offers/"
    },
    myTrips: {
      label: 'My Trips',
      subLabel: {
        singular: 'Upcoming Trip',
        plural: "Upcoming Trips"
      },
      icon: 'mytrip',
      url: origin + "/travelhistory"
    },
    gotTribe: {
      label: '',
      subLabel: {
        member: 'View membership benefits',
        nonMember: 'Travel more to get enrolled!'
      },
      icon: 'gotribe',
      goTribeIcon: 'gotribeLogo',
      url: origin + "/loyalty/"
    },
    goCash: {
      label: 'goCash',
      subLabel: 'Current Balance : ',
      subLabelGuest: 'Signup to get ₹100 goCash',
      icon: 'gocash',
      url: origin + "/gocash/"
    },
    logout: {
      label: 'Logout',
      icon: 'logout-icon'
    },
    student: {
      label: 'Student Go Pass',
      subLabel: {
        Verified: 'Explore Benefits',
        Unverified: 'Claim Benefits',
        Expired: 'Benefit expired'
      },
      status: {
        Verified: 'Verified',
        Unverified: 'Unverified',
        Expired: 'Expired'
      },
      icon: 'student',
      url: origin + "/student/landing/"
    }
  };
};
var W_RUPEE_SIGN = '₹';
var W_MY_TRIPS = function W_MY_TRIPS(origin) {
  if (origin === void 0) {
    origin = '';
  }
  return {
    label: 'My Trips',
    icon: 'mytrip-icon',
    tooltip: 'Access your bookings, easy cancellation, date change and much more',
    manageBooking: 'Manage Booking',
    url: W_USER_PROFILE_DROPDOWN(origin).myTrips.url
  };
};
var W_LOGIN_WIDGET_CTA = [{
  text: 'Login / Signup',
  id: 'text_1'
}, {
  text: 'Exclusive Offers',
  id: 'text_2'
}, {
  text: 'Earn goCash',
  id: 'text_3'
}, {
  text: 'Manage Your Trips',
  id: 'text_4'
}];

var LOBS_NAME = {
  FLIGHTS: 'Flights',
  HOTELS: 'Hotels',
  HOLIDAYS: 'Holidays',
  BUS: 'Bus',
  CABS: 'Cabs',
  TRAINS: 'Trains',
  VISA: 'Visa',
  FOREX: 'Forex',
  INSURANCE: 'Insurance'
};
var LOBS_CATG = {
  FLIGHTS: 'flights',
  HOTELS: 'hotels',
  BUS: 'bus',
  CABS: 'cabs',
  TRAINS: 'trains',
  HOLIDAYS: 'holidays',
  ACTIVITIES: 'activities',
  GROWTH: 'growth',
  COMMON: 'common',
  METRO: 'metro',
  VISA: 'visa',
  FOREX: 'forex',
  INSURANCE: 'Insurance'
};
var DEFAULT_PROFILE_NAME = 'Traveller';
var DWEB_HEADER_CONFIG = "growth-dweb-header-config";
var DWEB_HEADER_COUNTRY_LIST_CONFIG = "growth_country_list_config";
var STUDENT_STATUS = {
  verified: 'Verified',
  unverified: 'Unverified',
  expired: 'Expired'
};

var _templateObject$a, _templateObject2$8, _templateObject3$8, _templateObject4$4, _templateObject5$3, _templateObject6$3, _templateObject7$3;
var TabContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\tposition: relative;\n\tmin-height: 40px;\n\twidth: 108px;\n\tmargin-right: 20px;\n\n\t&:hover .tooltip {\n\t\tdisplay: block;\n\t\tz-index: 9999999;\n\t}\n"])));
var MyTripTab = (0,styled_components_browser_esm/* default */.ZP)(TabContainer)(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteralLoose(["\n\twidth: 148px;\n"])));
var NavLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteralLoose([""])));
var Tooltip = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tbackground: #fff;\n\tborder: 1px solid #e3e3e3;\n\tborder-radius: 4px;\n\tbox-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);\n\twidth: 250px;\n\tpadding: 10px 12px 10px 30px;\n\ttop: 52px;\n\tleft: -66px;\n\tdisplay: none;\n\tcolor: #46484d;\n\n\t", ":hover & {\n\t\tdisplay: block;\n\t\tz-index: 9999999;\n\t}\n\n\t&::after,\n\t&::before {\n\t\tbottom: 100%;\n\t\tleft: 50%;\n\t\tborder: solid transparent;\n\t\tcontent: '';\n\t\theight: 0;\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tpointer-events: none;\n\t}\n\n\t&::after {\n\t\tborder-color: rgba(255, 255, 255, 0);\n\t\tborder-bottom-color: #fff;\n\t\tborder-width: 8px;\n\t\tmargin-left: -8px;\n\t}\n\n\t&::before {\n\t\tborder-color: rgba(227, 227, 227, 0);\n\t\tborder-bottom-color: #e3e3e3;\n\t\tborder-width: 9px;\n\t\tmargin-left: -9px;\n\t}\n\n\tp::before {\n\t\tcontent: '';\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder-radius: 100%;\n\t\tbackground: #50e3c2;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tleft: 12px;\n\t\ttop: 12px;\n\t}\n"])), MyTripTab);
var NavIcon = styled_components_browser_esm/* default.span */.ZP.span(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteralLoose(["\n\tmargin-right: 10px;\n"])));
var NotificationTag = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteralLoose(["\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 100%;\n\tbackground: #ffea67;\n\tborder: solid 1px #fba707;\n\tfont-size: 10px;\n\tcolor: #000;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: absolute;\n\ttop: 17px;\n\tleft: 12px;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteralLoose(["\n\tbackground: url(https://gos3.ibcdn.com/gocash-1656061010.png);\n\theight: 24px;\n\twidth: 30px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n"])));

var NavWidgets = function NavWidgets(props) {
  var upcomingTrip = props.upcomingTrip,
    isLoggedIn = props.isLoggedIn,
    navOrigin = props.navOrigin,
    lobName = props.lobName;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
    _useAnalytics.pdt;
    var adobe = _useAnalytics.adobe;
  function sendGAEvent(linkName, url) {
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: linkName,
        type: 'itemClick',
        componentName: 'header',
        destination: url
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)("header_click_" + linkName, {
      event_detail: {
        event_type: "click_event|shopper_click",
        event_value: "" + lobName
      }
    });
  }
  var mytrip = W_MY_TRIPS(navOrigin);
  return /*#__PURE__*/react.createElement(NavLink, {
    href: mytrip.url,
    onClick: function onClick() {
      return sendGAEvent('my_trips', mytrip.url);
    }
  }, /*#__PURE__*/react.createElement(MyTripTab, {
    role: "presentation"
  }, /*#__PURE__*/react.createElement(NavIcon, {
    className: "header-sprite " + mytrip.icon
  }), isLoggedIn && upcomingTrip ? /*#__PURE__*/react.createElement(NotificationTag, null, upcomingTrip) : null, /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1",
    style: {
      color: isLoggedIn ? '#0074eb' : '#46484D'
    }
  }, mytrip.manageBooking), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "BaseW2",
    style: {
      color: '#333'
    }
  }, mytrip.label))), /*#__PURE__*/react.createElement(Tooltip, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1"
  }, mytrip.tooltip))));
};

/*
 * You can change the LOBS nav item in header by changing the below array
 * item order
 *
 * If you are adding a new LOB in this list, make sure 'HeaderUrlConfig'
 * must have the require config for that new LOB.
 */
var lobsListInOrder = ['FLIGHTS', 'HOTELS', 'TRAINS', 'CABS', 'BUS', 'HOLIDAYS', 'FOREX', 'INSURANCE'];
var lobsPathName = {
  HOME: '/',
  FLIGHTS: '/flights/',
  HOTELS: '/hotels/',
  TRAINS: '/trains/',
  CABS: '/cars/',
  BUS: '/bus/',
  VISA: '/visa/',
  HOLIDAYS: '/giholidays/',
  INSURANCE: '/insurance?cmp=desktop_header',
  FOREX: 'https://tripmoney.goibibo.com/partners/gi/forex/listing?utm_source=header_goibibo&utm_medium=desktop'
};
var lobOffersPath = {
  flights: 'flight-offers/',
  hotels: 'hotel-offers/',
  cabs: 'gocar-offers/',
  trains: 'train-offers/',
  bus: 'bus-offers/'
};

/*
 * Assuming as LOBs pages will be in `/`  path of origin(https://goibibo.com/<lobpage>) if not then lobs can
 pass navOrigin as prop to replace it.
 eg:
 navOrigin: "https://www.goibibo.com" if header is integrated in subdomain or other domain than goibibo.com
 */

// @private
function getNavListUrls(origin) {
  if (origin === void 0) {
    origin = '';
  }
  var urls = {
    FLIGHTS: {
      URL: origin + lobsPathName.FLIGHTS,
      LABEL: LOBS_NAME.FLIGHTS,
      CATEGORY: LOBS_CATG.FLIGHTS,
      ICON: 'flights' // sprite icons class name
    },

    HOTELS: {
      URL: origin + lobsPathName.HOTELS,
      LABEL: LOBS_NAME.HOTELS,
      CATEGORY: LOBS_CATG.HOTELS,
      ICON: 'hotels'
    },
    TRAINS: {
      URL: origin + lobsPathName.TRAINS,
      LABEL: LOBS_NAME.TRAINS,
      CATEGORY: LOBS_CATG.TRAINS,
      ICON: 'trains'
    },
    CABS: {
      URL: origin + lobsPathName.CABS,
      LABEL: LOBS_NAME.CABS,
      CATEGORY: LOBS_CATG.CABS,
      ICON: 'cabs'
    },
    BUS: {
      URL: origin + lobsPathName.BUS,
      LABEL: LOBS_NAME.BUS,
      CATEGORY: LOBS_CATG.BUS,
      ICON: 'bus'
    },
    VISA: {
      URL: origin + lobsPathName.VISA,
      LABEL: LOBS_NAME.VISA,
      CATEGORY: LOBS_CATG.VISA,
      ICON: 'visa',
      NEW: false
    },
    FOREX: {
      URL: lobsPathName.FOREX,
      LABEL: LOBS_NAME.FOREX,
      CATEGORY: LOBS_CATG.FOREX,
      ICON: 'forex',
      TARGET_BLANK: true
    },
    HOLIDAYS: {
      URL: origin + lobsPathName.HOLIDAYS,
      LABEL: LOBS_NAME.HOLIDAYS,
      CATEGORY: LOBS_CATG.HOLIDAYS,
      ICON: 'holiday',
      TARGET_BLANK: true
    },
    INSURANCE: {
      URL: origin + lobsPathName.INSURANCE,
      LABEL: LOBS_NAME.INSURANCE,
      CATEGORY: LOBS_CATG.INSURANCE,
      ICON: 'insurance',
      TARGET_BLANK: false
    }
  };
  return urls;
}
function generateMainNavList(list, navUrls) {
  var finalList = [];
  list.forEach(function (item) {
    var l = {
      url: navUrls[item].URL,
      path: navUrls[item].PATHNAME,
      label: navUrls[item].LABEL,
      icon: navUrls[item].ICON,
      "new": navUrls[item].NEW || false,
      targetBlank: navUrls[item].TARGET_BLANK || false,
      category: navUrls[item].CATEGORY
    };
    finalList.push(l);
  });
  return finalList;
}
var lobsNavList = function lobsNavList(origin) {
  return generateMainNavList(lobsListInOrder, getNavListUrls(origin));
};

var _templateObject$9, _templateObject2$7, _templateObject3$7, _templateObject4$3, _templateObject5$2, _templateObject6$2, _templateObject7$2, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24;
var LoginDropdown = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tbackground: #fff;\n\tborder: 1px solid #e3e3e3;\n\tborder-radius: 8px;\n\tbox-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);\n\twidth: 260px;\n\tpadding: 10px 20px;\n\tfont-size: 12px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tz-index: 1000;\n\tcolor: #46484d;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteralLoose(["\n\tflex-direction: column;\n\talign-items: flex-start !important;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteralLoose(["\n\tmargin-bottom: 1px !important;\n\tcolor: #4e525b;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteralLoose(["\n\tcolor: #4e525b;\n\tmargin-bottom: 12px !important;\n"])));
var DropdownListItem = styled_components_browser_esm/* default.a */.ZP.a(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tborder-bottom: solid 1px #efefef;\n\tpadding: 8px 0;\n\tcursor: pointer;\n\tcolor: #46484d !important;\n\t&:first-of-type {\n\t\tborder-bottom: 0;\n\t}\n\t&:last-of-type {\n\t\tborder-bottom: 0;\n\t}\n\t&:visited {\n\t\tcolor: #46484d;\n\t}\n"])));
var DropdownLoginWrap = styled_components_browser_esm/* default.li */.ZP.li(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteralLoose(["\n\tlist-style: none;\n\tmargin: 8px 0px;\n"])));
var DropdownLinkUser = styled_components_browser_esm/* default.a */.ZP.a(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n"])));
var GotribeInfoWrap$1 = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: column;\n"])));
var GotribeBadge$1 = styled_components_browser_esm/* default.img */.ZP.img(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteralLoose(["\n\twidth: auto;\n    margin-left:", ";\n    height: ", ";\n"])), function (props) {
  return props.hasTier ? '-3px' : '0';
}, function (props) {
  return props.hasTier ? '25px' : '16px';
});
var GotribeOldBadge = styled_components_browser_esm/* default.img */.ZP.img(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteralLoose(["\n\twidth: auto;\n    margin-left: 0;\n    height: 16px;\n"])));
var DropdownLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n"])));
var DropdownLinkWrapLoyalty = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
styled_components_browser_esm/* default.a */.ZP.a(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n\tcolor: #2276e3;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\n\timg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 50%;\n\t}\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n\twidth: 22px;\n\theight: 22px;\n\ttop: 1px;\n\tfont-size: 14px;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["\n\theight: 8px;\n\twidth: 32px;\n\tdisplay: inline-block;\n\tbackground: #e3e3e3;\n"])));
var DropdownMenuWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["\n\tflex: 1;\n"])));
var DropdownSprite = styled_components_browser_esm/* default.div */.ZP.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["\n\tmargin-right: 20px;\n"])));
styled_components_browser_esm/* default.img */.ZP.img(_templateObject19 || (_templateObject19 = _taggedTemplateLiteralLoose(["\n\tmargin-right: 20px;\n"])));
var LoginButton = styled_components_browser_esm/* default.button */.ZP.button(_templateObject20 || (_templateObject20 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 36px;\n\tborder-radius: 8px;\n\tbackground-color: #2276e3;\n\t", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: #fff;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);
var ProfileItemWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteralLoose(["\n\tflex: 1 1 0%;\n\tmargin-left: 8px;\n"])));
var ItemLabel = styled_components_browser_esm/* default.p */.ZP.p(_templateObject22 || (_templateObject22 = _taggedTemplateLiteralLoose(["\n\t", "\n\tmargin-bottom: 3px;\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);
var ItemSideLabel = styled_components_browser_esm/* default.span */.ZP.span(_templateObject23 || (_templateObject23 = _taggedTemplateLiteralLoose(["\n\t", "\n\t\t", "\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1, function (_ref) {
  var sideLabelStyle = _ref.sideLabelStyle;
  switch (sideLabelStyle) {
    case STUDENT_STATUS.verified:
      return 'color: #4caf50;';
    case STUDENT_STATUS.expired:
      return 'color: #f44336;';
    case STUDENT_STATUS.unverified:
      return 'color: #ff9800;';
    default:
      return 'color: #ff9800;';
    // Default color
  }
});

var ItemSubLabel = styled_components_browser_esm/* default.p */.ZP.p(_templateObject24 || (_templateObject24 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #4e525b;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);

var DropDownItemGeneric = function DropDownItemGeneric(_ref) {
  var navOrigin = _ref.navOrigin,
    sendEvent = _ref.sendEvent,
    listItem = _ref.listItem,
    itemChild = _ref.itemChild;
  var url = listItem.url,
    label = listItem.label,
    subLabel = listItem.subLabel,
    icon = listItem.icon,
    sideLabel = listItem.sideLabel;
  return /*#__PURE__*/react.createElement(DropdownListItem, {
    href: generateDropDownUrl(url, navOrigin),
    onClick: function onClick() {
      return sendEvent({
        link: label
      });
    }
  }, /*#__PURE__*/react.createElement(DropdownSprite, {
    className: "dropdown-sprite " + icon
  }), /*#__PURE__*/react.createElement(DropdownMenuWrap, null, /*#__PURE__*/react.createElement(ItemLabel, null, label, sideLabel ? /*#__PURE__*/react.createElement(ItemSideLabel, {
    sideLabelStyle: sideLabel
  }, " (", sideLabel, ")") : null), /*#__PURE__*/react.createElement(ItemSubLabel, null, itemChild || subLabel)));
};
DropDownItemGeneric.defaultProps = {
  itemChild: undefined
};

var DropDownItemLoyalty = function DropDownItemLoyalty(_ref) {
  var memberType = _ref.memberType,
    navOrigin = _ref.navOrigin,
    sendEvent = _ref.sendEvent,
    isLoggedIn = _ref.isLoggedIn,
    program = _ref.program,
    dropDownList = _ref.dropDownList;
  // a user should be logged in and should be enrolled into new program and has a tier(memberType) to show the new icon
  var showNewIcon = isLoggedIn && program === newProgram;
  var showOldIcon = !isLoggedIn || isLoggedIn && program === oldProgram;
  return /*#__PURE__*/react.createElement(DropdownListItem, {
    as: "span"
  }, /*#__PURE__*/react.createElement(DropdownLink, {
    href: generateDropDownUrl(dropDownList.gotTribe.url, navOrigin),
    onClick: function onClick() {
      return sendEvent({
        link: 'go_tribe',
        memberType: memberType
      });
    }
  }, /*#__PURE__*/react.createElement(DropdownSprite, {
    className: "dropdown-sprite " + dropDownList.gotTribe.icon
  }), /*#__PURE__*/react.createElement(DropdownMenuWrap, null, /*#__PURE__*/react.createElement(DropdownLinkWrapLoyalty, null, /*#__PURE__*/react.createElement(GotribeInfoWrap$1, null, showNewIcon ? /*#__PURE__*/react.createElement(GotribeBadge$1, {
    hasTier: memberType > 0,
    src: GotribeLogoMapping[memberType] || GuestUserGotribeLogo
  }) : /*#__PURE__*/react.createElement(react.Fragment, null), showOldIcon ? /*#__PURE__*/react.createElement(GotribeOldBadge, {
    src: GuestUserGotribeLogo
  }) : /*#__PURE__*/react.createElement(react.Fragment, null))), /*#__PURE__*/react.createElement(ItemSubLabel, null, "Travel and save more"))));
};

var _templateObject$8, _templateObject2$6, _templateObject3$6;
var AvatarWrap = styled_components_browser_esm/* default.span */.ZP.span(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\tborder-radius: 100%;\n\toverflow: hidden;\n\tmargin-right: 5px;\n\n\timg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 50%;\n\t}\n\t", "\n"])), function (_ref) {
  var image = _ref.image;
  return !image ? (0,styled_components_browser_esm/* css */.iv)(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteralLoose(["\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbackground: linear-gradient(225deg, #ff3e5e, #ff7f3f);\n\t\t\t  "]))) : '';
});
var ProfileNameChar = styled_components_browser_esm/* default.span */.ZP.span(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\tfont-stretch: normal;\n\tfont-style: normal;\n\tletter-spacing: normal;\n\tcolor: #fff;\n\ttext-align: center;\n\tposition: absolute;\n\ttop: 4px;\n"])));

var _templateObject$7, _templateObject2$5, _templateObject3$5, _templateObject4$2;
var placeHolderShimmer = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n0% {\n\tbackground-position: -468px 0;\n}\n\n100% {\n\tbackground-position: 468px 0;\n}\n"])));
var Shimmer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteralLoose(["\n\tanimation-duration: 1s;\n\tanimation-fill-mode: forwards;\n\tanimation-iteration-count: infinite;\n\tanimation-name: ", ";\n\tanimation-timing-function: linear;\n\tbackground: #f6f7f8;\n\tbackground: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);\n\tbackground-size: 800px 104px;\n\tposition: relative;\n"])), placeHolderShimmer);
var HorizontalShimmer = (0,styled_components_browser_esm/* default */.ZP)(Shimmer)(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteralLoose(["\n\twidth: 80%;\n\theight: 15px;\n"])));
var CircularShimmer = (0,styled_components_browser_esm/* default */.ZP)(Shimmer)(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n\tborder-radius: 50%;\n\twidth: 30px;\n\theight: 30px;\n"])));

var UserAvatar = function UserAvatar(props) {
  var image = props.image,
    firstName = props.firstName,
    isLoggedIn = props.isLoggedIn,
    loading = props.loading;
  var getNameFirstChar = (0,react.useCallback)(function () {
    return getUserNameInitials(firstName);
  }, [firstName]);
  if (isLoggedIn) {
    return /*#__PURE__*/react.createElement(AvatarWrap, {
      image: image
    }, image ? /*#__PURE__*/react.createElement("img", {
      src: image,
      style: {
        objectFit: 'cover'
      },
      alt: getNameFirstChar()
    }) : /*#__PURE__*/react.createElement(ProfileNameChar, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
      size: "MediumW3"
    }, getNameFirstChar())));
  }
  if (loading) {
    return /*#__PURE__*/react.createElement(CircularShimmer, null);
  }
  if (image) {
    return /*#__PURE__*/react.createElement(AvatarWrap, {
      image: image
    }, /*#__PURE__*/react.createElement("img", {
      src: image,
      style: {
        objectFit: 'cover'
      },
      alt: "avatar"
    }));
  }
  return /*#__PURE__*/react.createElement("span", {
    className: "header-sprite user-icon",
    style: {
      marginRight: '5px'
    }
  });
};

var DropDownItemUserProfile = function DropDownItemUserProfile(_ref) {
  var onViewProfileClick = _ref.onViewProfileClick,
    userImage = _ref.userImage,
    fullName = _ref.fullName,
    isLoggedIn = _ref.isLoggedIn,
    onLoginCtaClick = _ref.onLoginCtaClick,
    navOrigin = _ref.navOrigin,
    dropDownList = _ref.dropDownList;
  return /*#__PURE__*/react.createElement(DropdownLoginWrap, null, !isLoggedIn ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "MediumW2",
    style: {
      marginBottom: '1px',
      color: '#4e525b'
    }
  }, dropDownList.login.label), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1",
    style: {
      marginBottom: '12px',
      color: '#4e525b'
    }
  }, dropDownList.login.subLabel), /*#__PURE__*/react.createElement(LoginButton, {
    onClick: function onClick() {
      return onLoginCtaClick('login-cta-dropdown');
    },
    type: "button"
  }, dropDownList.login.ctaText)) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(DropdownLinkUser, {
    href: generateDropDownUrl(dropDownList.view_profile.url, navOrigin),
    onClick: onViewProfileClick
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: userImage,
    firstName: fullName,
    isLoggedIn: true
  }), /*#__PURE__*/react.createElement(ProfileItemWrap, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#4e525b",
    size: "MediumW2",
    style: {
      marginBottom: '3px',
      textTransform: 'capitalize'
    }
  }, fullName), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1",
    style: {
      color: '#2276e3'
    }
  }, dropDownList.view_profile.label, ' ')))));
};

/** Create a new configStore instance for desktop header */
var useConfigStore = (0,growth_config_store_browser_esm/* createConfigStore */.Ao)();

var UserDropDown = function UserDropDown(props) {
  var _configData$COMMON, _headerConfigData$dat, _userInfo$altVerified, _dropDownList$student, _dropDownList$student2, _dropDownList$student3, _dropDownList$student4, _dropDownList$student5, _dropDownList$goCash, _dropDownList$giftCar;
  var userInfo = props.userInfo,
    hideDropDown = props.hideDropDown,
    memberType = props.memberType,
    program = props.program,
    upcomingTripCount = props.upcomingTripCount,
    isLoggedIn = props.isLoggedIn,
    _onLoginCtaClick = props.onLoginCtaClick,
    lobName = props.lobName,
    navOrigin = props.navOrigin,
    positionStyle = props.positionStyle,
    isBlackListedUser = props.isBlackListedUser;
  var configData = useConfigStore(function (s) {
    return s.data;
  });
  var headerConfigData = configData == null || (_configData$COMMON = configData.COMMON) == null ? void 0 : _configData$COMMON[DWEB_HEADER_CONFIG];
  var dropDownList = (headerConfigData == null || (_headerConfigData$dat = headerConfigData.data) == null ? void 0 : _headerConfigData$dat.dropdownOptionsList) || W_USER_PROFILE_DROPDOWN(navOrigin) || {};
  var _useGoCashBalanceStor = (0,growth_data_store_esm/* useGoCashBalanceStore */.JK)(),
    gocashData = _useGoCashBalanceStor.data,
    gocashLoading = _useGoCashBalanceStor.loading;
  var balance = gocashData.balance;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    pdt = _useAnalytics.pdt,
    adobe = _useAnalytics.adobe;
  var handleOutsideClick = function handleOutsideClick(e) {
    var el = e.target;
    var dropdownContainer = el.closest('ul.login__dropdown');
    if (!dropdownContainer) {
      hideDropDown();
    }
  };
  var sendEvent = function sendEvent(eventObj) {
    pdt.track('HAPPY_HEADER_WEBA__CLICK_DROPDOWN_LINK', {
      item_selected: eventObj.link
    });
    adobe.track('ctaClick', {
      cta: {
        name: eventObj.link,
        type: 'itemClick',
        componentName: 'Header Dropdown'
      }
    });
  };
  var handleViewProfile = function handleViewProfile() {
    sendEvent({
      link: 'view_profile'
    });
  };
  (0,react.useEffect)(function () {
    document.addEventListener('click', handleOutsideClick);
    return function () {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);
  var getOffersUrl = function getOffersUrl() {
    var _dropDownList$offers;
    var offersUrl = dropDownList == null || (_dropDownList$offers = dropDownList.offers) == null ? void 0 : _dropDownList$offers.url;
    if (lobName && lobOffersPath[lobName]) {
      return "" + offersUrl + lobOffersPath[lobName];
    }
    return offersUrl;
  };
  var fullName = userInfo != null && userInfo.firstName ? (userInfo == null ? void 0 : userInfo.firstName) + " " + ((userInfo == null ? void 0 : userInfo.lastName) || '') : DEFAULT_PROFILE_NAME;
  var studentStatus = STUDENT_STATUS[userInfo == null || (_userInfo$altVerified = userInfo.altVerifiedDetails) == null || (_userInfo$altVerified = _userInfo$altVerified[0]) == null ? void 0 : _userInfo$altVerified.status] || STUDENT_STATUS.unverified;
  return /*#__PURE__*/react.createElement(LoginDropdown, {
    style: positionStyle,
    "data-id": "header-dropdown"
  }, /*#__PURE__*/react.createElement(DropDownItemUserProfile, {
    onViewProfileClick: handleViewProfile,
    userImage: userInfo == null ? void 0 : userInfo.profileImage,
    fullName: fullName,
    isLoggedIn: isLoggedIn,
    onLoginCtaClick: function onLoginCtaClick() {
      return _onLoginCtaClick({
        name: 'login-cta-dropdown',
        componentName: 'Header Dropdown'
      });
    },
    navOrigin: navOrigin,
    dropDownList: dropDownList
  }), !isBlackListedUser ? /*#__PURE__*/react.createElement(DropDownItemLoyalty, {
    program: program,
    memberType: memberType,
    navOrigin: navOrigin,
    sendEvent: sendEvent,
    isLoggedIn: isLoggedIn,
    dropDownList: dropDownList
  }) : null, /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: _extends({}, dropDownList.offers, {
      url: getOffersUrl()
    }),
    navOrigin: navOrigin
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: _extends({}, dropDownList.student, {
      sideLabel: (dropDownList == null || (_dropDownList$student = dropDownList.student) == null || (_dropDownList$student = _dropDownList$student.status) == null ? void 0 : _dropDownList$student[studentStatus]) || (dropDownList == null || (_dropDownList$student2 = dropDownList.student) == null || (_dropDownList$student2 = _dropDownList$student2.status) == null ? void 0 : _dropDownList$student2.Unverified),
      subLabel: (dropDownList == null || (_dropDownList$student3 = dropDownList.student) == null || (_dropDownList$student3 = _dropDownList$student3.subLabel) == null ? void 0 : _dropDownList$student3[studentStatus]) || (dropDownList == null || (_dropDownList$student4 = dropDownList.student) == null || (_dropDownList$student4 = _dropDownList$student4.subLabel) == null ? void 0 : _dropDownList$student4.Unverified),
      url: dropDownList == null || (_dropDownList$student5 = dropDownList.student) == null ? void 0 : _dropDownList$student5.url
    }),
    navOrigin: navOrigin
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: dropDownList.myTrips,
    navOrigin: navOrigin,
    itemChild: /*#__PURE__*/react.createElement(react.Fragment, null, upcomingTripCount ? upcomingTripCount + "\n                " + (upcomingTripCount > 1 ? dropDownList.myTrips.subLabel.plural : dropDownList.myTrips.subLabel.singular) : 'Manage your bookings')
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    navOrigin: navOrigin,
    listItem: dropDownList.goCash,
    itemChild: /*#__PURE__*/react.createElement(react.Fragment, null, isLoggedIn ? /*#__PURE__*/react.createElement(react.Fragment, null, dropDownList.goCash.subLabel, /*#__PURE__*/react.createElement("span", {
      className: "gr-bold"
    }, gocashLoading ? /*#__PURE__*/react.createElement("span", {
      className: "gocashLoading"
    }) : /*#__PURE__*/react.createElement(react.Fragment, null, W_RUPEE_SIGN, balance))) : /*#__PURE__*/react.createElement(react.Fragment, null, (_dropDownList$goCash = dropDownList.goCash) == null ? void 0 : _dropDownList$goCash.subLabelGuest))
  }), (dropDownList == null ? void 0 : dropDownList.giftCard) && /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: _extends({}, dropDownList == null ? void 0 : dropDownList.giftCard, {
      url: dropDownList == null || (_dropDownList$giftCar = dropDownList.giftCard) == null ? void 0 : _dropDownList$giftCar.url
    }),
    navOrigin: navOrigin
  }));
};

var _templateObject$6, _templateObject2$4, _templateObject3$4, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
var LoginTab = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n\twidth: 164px;\n\tposition: relative;\n\theight: 44px;\n\tbackground-color: #fff;\n\ttransition: all 0.4s ease;\n\tmargin-right: 2px;\n\n\t.gr-user {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 100%;\n\t\toverflow: hidden;\n\n\t\timg {\n\t\t\twidth: 28px;\n\t\t\theight: 28px;\n\t\t\tborder-radius: 50%;\n\t\t}\n\n\t\t&.name__text {\n\t\t\tbackground-image: linear-gradient(225deg, #ff3e5e, #ff7f3f);\n\t\t\tfont-size: 16px;\n\t\t\tcolor: #fff;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n\n\t.you-are {\n\t\tvertical-align: bottom;\n\t}\n\n\t.horizontal_shimmer {\n\t\tmargin-left: 12px;\n\t}\n\t@media (min-width: 800px) and (max-width: 1199px) {\n\tmargin-right: 22px;\n\n\t}\n"])));
var UserNameWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);
var UserNameText = styled_components_browser_esm/* default.span */.ZP.span(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmax-width: 70px;\n\tvertical-align: bottom !important;\n\ttext-transform: capitalize;\n\tmargin-left: 4px;\n"])));
var LoginTabWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 100%;\n\tborder-radius: 8px;\n\tborder: solid 1px #2276e3;\n\tpadding: 0 8px;\n\tcursor: pointer;\n    overflow: hidden;\n"])));
var ScrollItemWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var SignUpCtaTextWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose([""])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 1px;\n\theight: 29px;\n\tborder-right: solid 1px #eff3f8;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n\tmargin: 0 0 0 2px;\n\tpadding: 1px 5px 2px 5px;\n\tborder-radius: 7px;\n\tcolor: #fff;\n\tfont-size: 8px;\n\tbackground-image: linear-gradient(to right, #e63148 40%, #ff4e00);\n\n\t&.super {\n\t\tbackground-image: linear-gradient(to right, #fa961a 19%, #ffb305 95%);\n\t}\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tmax-width: 50px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n\tmax-width: 70px;\n\tvertical-align: bottom !important;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n\theight: 24px;\n\twidth: 24px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: contain;\n\tmargin-right: 2px;\n\tmargin-left: 4px;\n"])));
var ArrowIcon = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n\tborder: solid #2274e0;\n\tborder-width: 0 2px 2px 0;\n\tdisplay: inline-block;\n\tpadding: 2px;\n\tmargin-left: auto;\n\n\t&.right {\n\t\ttransform: rotate(-45deg);\n\t\t-webkit-transform: rotate(-45deg);\n\t}\n\n\t&.left {\n\t\ttransform: rotate(135deg);\n\t\t-webkit-transform: rotate(135deg);\n\t}\n\n\t&.up {\n\t\ttransform: rotate(-135deg);\n\t\t-webkit-transform: rotate(-135deg);\n\t}\n\n\t&.down {\n\t\ttransform: rotate(45deg);\n\t\t-webkit-transform: rotate(45deg);\n\t}\n"])));

var _templateObject$5, _templateObject2$3, _templateObject3$3;
var MainWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    overflow: hidden;\n    width: 100vw;\n    max-width: 100%;\n"])));
var List = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  /* overflow: hidden; */\n  transform: ", ";\n    transition: transform 300ms ease-in-out;\n    -webkit-transition: transform 300ms ease-in-out;\n"])), function (props) {
  return "translateY(-" + props.height + ")";
});
var ListItem = styled_components_browser_esm/* default.li */.ZP.li(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  width: 200px;\n  ", ";\n  color: #2276E3;\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);

var Carousal = function Carousal(_ref) {
  var _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list,
    contentHeight = _ref.contentHeight,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? false : _ref$loop,
    _ref$loopCount = _ref.loopCount,
    loopCount = _ref$loopCount === void 0 ? 1 : _ref$loopCount;
  var listCount = list.length;
  var listRef = (0,react.useRef)(null);
  var positionRef = (0,react.useRef)(-contentHeight);
  var duration = 0.5;
  var endPosition = listCount * -contentHeight;
  var RotationCount = (0,react.useRef)(1);
  var timeoutId = (0,react.useRef)();
  function nextSlide() {
    if (!listRef.current) {
      return;
    }
    positionRef.current -= contentHeight;
    if (listRef.current) {
      listRef.current.style.transform = "translateY(" + positionRef.current + "px)";
      listRef.current.style.transitionDuration = duration + "s";
    }
  }
  function rotateSlide() {
    if (!listRef.current) {
      return;
    }
    positionRef.current = -contentHeight;
    setTimeout(function () {
      if (listRef.current) {
        listRef.current.style.transform = "translateY(-" + contentHeight + "px)";
        listRef.current.style.transitionDuration = '0s';
      }
    }, 1000);
  }
  var rotate = function rotate() {
    if (!listRef.current) {
      return;
    }
    if (positionRef.current === endPosition) {
      nextSlide();
      rotateSlide();
      RotationCount.current += 1;
    } else {
      nextSlide();
    }
    if (RotationCount.current <= loopCount) {
      timeoutId.current = setTimeout(function () {
        rotate();
      }, 2000);
    }
  };
  (0,react.useEffect)(function () {
    // if list length is greater than 1 and loop is true make loop 2 times otherwise only once
    if (listCount > 1) {
      if (loop) {
        timeoutId.current = setTimeout(function () {
          rotate();
        }, 2000);
      } else {
        timeoutId.current = setTimeout(function () {
          rotate();
        }, 2000);
      }
    }
    return function () {
      if (timeoutId.current) clearTimeout(timeoutId.current);
    };
  }, [loop, listCount]);
  var isTextItem = function isTextItem(item) {
    return typeof item === 'object' && 'text' in item;
  };
  var lastItem = list[listCount - 1];
  var firstItem = list[0];
  return /*#__PURE__*/react.createElement(MainWrapper, {
    style: {
      height: contentHeight + "px"
    }
  }, /*#__PURE__*/react.createElement(List, {
    ref: listRef,
    height: contentHeight + "px"
  }, /*#__PURE__*/react.createElement(ListItem, {
    style: {
      height: contentHeight + "px"
    }
  }, isTextItem(lastItem) ? lastItem.text : /*#__PURE__*/react.createElement(lastItem.component, lastItem.props)), list.map(function (item, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      react.createElement(ListItem, {
        key: "txt_para_" + index,
        style: {
          height: contentHeight + "px"
        }
      }, isTextItem(item) ? item.text : /*#__PURE__*/react.createElement(item.component, item.props))
    );
  }), /*#__PURE__*/react.createElement(ListItem, {
    style: {
      height: contentHeight + "px"
    }
  }, isTextItem(firstItem) ? firstItem.text : /*#__PURE__*/react.createElement(firstItem.component, firstItem.props))));
};

var GuestDetails = function GuestDetails() {
  var contentToScroll = [].concat(W_LOGIN_WIDGET_CTA);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(UserAvatar, null), /*#__PURE__*/react.createElement(SignUpCtaTextWrap, {
    role: "presentation",
    id: "get_sign_in"
  }, /*#__PURE__*/react.createElement(Carousal, {
    list: contentToScroll,
    contentHeight: 16,
    loop: false,
    loopCount: 1
  })));
};

var _templateObject$4, _templateObject2$2, _templateObject3$2;
var GotribeInfoWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: column;\n"])));
var GotribeBadge = styled_components_browser_esm/* default.img */.ZP.img(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n\twidth: 70px;\n"])));
var GotribeOlBadge = styled_components_browser_esm/* default.img */.ZP.img(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n\twidth: 50px;\n\theight: 14px;\n"])));

var GoTribeMember = function GoTribeMember(props) {
  var memberType = props.memberType,
    program = props.program;
  var showBadgeForOldUser = memberType > 0 && program === oldProgram;
  var showBadgeForNewUser = memberType > 0 && program === newProgram;
  return /*#__PURE__*/react.createElement(react.Fragment, null, showBadgeForNewUser ? /*#__PURE__*/react.createElement(GotribeInfoWrap, null, /*#__PURE__*/react.createElement(GotribeBadge, {
    src: GotribeLogoMapping[memberType]
  })) : /*#__PURE__*/react.createElement(react.Fragment, null), showBadgeForOldUser ? /*#__PURE__*/react.createElement(GotribeInfoWrap, null, /*#__PURE__*/react.createElement(GotribeOlBadge, {
    src: GuestUserGotribeLogo
  })) : /*#__PURE__*/react.createElement(react.Fragment, null));
};

var UserDetails = function UserDetails(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
    loading = _ref.loading,
    profileImage = _ref.profileImage,
    firstName = _ref.firstName,
    loyaltyMemberTier = _ref.loyaltyMemberTier,
    isBlackListedUser = _ref.isBlackListedUser,
    program = _ref.program;
  return /*#__PURE__*/react.createElement(ScrollItemWrap, {
    style: {
      height: '32px'
    }
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: profileImage,
    firstName: firstName,
    isLoggedIn: isLoggedIn,
    loading: loading
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(UserNameWrap, null, /*#__PURE__*/react.createElement("span", null, "Hey"), /*#__PURE__*/react.createElement(UserNameText, null, firstName)), !isBlackListedUser ? /*#__PURE__*/react.createElement(GoTribeMember, {
    memberType: loyaltyMemberTier,
    program: program
  }) : null));
};

var GocashDetails = function GocashDetails(_ref) {
  var balance = _ref.balance,
    gocashLoading = _ref.gocashLoading;
  return /*#__PURE__*/react.createElement(ScrollItemWrap, {
    style: {
      height: '32px'
    }
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: "https://go-assets.ibcdn.com/u/GI/images/1710408879842-gocash-gold.png"
  }), /*#__PURE__*/react.createElement(UserNameWrap, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#000",
    size: "SmallW2"
  }, "Gocash"), !gocashLoading && /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#717171",
    size: "SmallW1",
    as: "span"
  }, "Balance:", /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#717171",
    size: "SmallW3",
    as: "span"
  }, "\u20B9", balance))));
};

var LoggedInDetails = function LoggedInDetails(_ref) {
  var loading = _ref.loading,
    profileImage = _ref.profileImage,
    firstName = _ref.firstName,
    loyaltyMemberTier = _ref.loyaltyMemberTier,
    isBlackListedUser = _ref.isBlackListedUser,
    program = _ref.program;
  var _useGoCashBalanceStor = (0,growth_data_store_esm/* useGoCashBalanceStore */.JK)(),
    gocashData = _useGoCashBalanceStor.data,
    gocashLoaded = _useGoCashBalanceStor.loaded,
    gocashLoading = _useGoCashBalanceStor.loading,
    gocashError = _useGoCashBalanceStor.error;
  var balance = gocashData.balance;
  var content = [{
    component: UserDetails,
    props: {
      isLoggedIn: true,
      firstName: firstName,
      loading: loading,
      profileImage: profileImage,
      loyaltyMemberTier: loyaltyMemberTier,
      isBlackListedUser: isBlackListedUser,
      program: program
    }
  }];

  /* add items in animation content */
  // Gocash

  if (gocashLoaded && !gocashError) {
    content.push({
      component: GocashDetails,
      props: {
        balance: balance,
        gocashLoading: gocashLoading
      }
    });
  }
  var contentToScroll = [].concat(content);
  return /*#__PURE__*/react.createElement(Carousal, {
    list: contentToScroll,
    contentHeight: 32,
    loop: true,
    loopCount: 2
  });
};

var UserLoginWidget = function UserLoginWidget(props) {
  var _useProfileStore = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
      return {
        $userDetails: s.data,
        loading: s.loading
      };
    }, shallow/* shallow */.X),
    $userDetails = _useProfileStore.$userDetails,
    loading = _useProfileStore.loading;
  var showLogin = props.showLogin,
    onLogoutSuccess = props.onLogoutSuccess,
    reloadAfterLogout = props.reloadAfterLogout,
    isLoginPopoverVisible = props.isLoginPopoverVisible,
    lobName = props.lobName,
    navOrigin = props.navOrigin,
    upComingTripCounts = props.upComingTripCounts;
  var _useState = (0,react.useState)(false),
    showUserDropDown = _useState[0],
    updateShowUserDropDown = _useState[1];
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var dropDownTimer;
  var hasMounted = (0,growth_custom_hooks_useHasMounted_esm/* useHasMounted */.f)();
  var loyaltyUserInfoData = (0,growth_data_store_esm/* useLoyaltyUserInfoStore */.yL)(function (s) {
    return s.data;
  });
  var loyaltyMemberTier = (0,growth_data_store_esm/* selectLoyaltyMemberType */.yY)(loyaltyUserInfoData);
  var gotribeStatus = loyaltyUserInfoData.status,
    program = loyaltyUserInfoData.program;
  var isControlledUser = getControlUser(gotribeStatus);
  var isBlackListedUser = getBlackListedUser(gotribeStatus);
  var handleLogout = function handleLogout() {
    updateShowUserDropDown(false);
    (0,growth_auth_helpers_esm/* fetchLogoutUser */.hM)({
      platform: 'dweb'
    }).then(function () {
      updateShowUserDropDown(false);
      growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT_SUCCESS);
      if (onLogoutSuccess) {
        growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT_SUCCESS);
        onLogoutSuccess();
      } else if (reloadAfterLogout) window.location.reload();
    });
  };
  (0,react.useEffect)(function () {
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT, function () {
      handleLogout();
    });
    return function () {
      return growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT, function () {
        handleLogout();
      });
    };
  }, []);
  var toggleUserDropDown = (0,react.useCallback)(function () {
    updateShowUserDropDown(!showUserDropDown);
  }, [showUserDropDown]);
  var handleOnLoginWidgetClick = function handleOnLoginWidgetClick(_ref) {
    var name = _ref.name,
      componentName = _ref.componentName;
    if (loading) return;
    if (!$userDetails.isLoggedIn) {
      (0,growth_pdt_push_esm/* pdtPush */.g)('header_click_login_btn', {
        event_detail: {
          event_type: 'click_event',
          event_value: lobName
        }
      });
      adobe.track('ctaClick', {
        cta: {
          name: "" + name,
          type: 'itemClick',
          componentName: componentName
        }
      });
      showLogin();
    } else {
      (0,growth_pdt_push_esm/* pdtPush */.g)('header_click_nav_widget', {
        event_detail: {
          event_type: 'click_event|shopper_click',
          event_value: lobName + "|" + name
        }
      });
      toggleUserDropDown();
    }
  };

  // using this function to show dropdown on hover
  var showDropDown = function showDropDown() {
    if (!isLoginPopoverVisible && !loading) {
      clearTimeout(dropDownTimer);
      updateShowUserDropDown(true);
    }
  };

  // function to hide dropdown on mouse leave and
  // adding delay so that when mouse leave user can focus on dropdown list
  var hideDropDown = function hideDropDown() {
    dropDownTimer = setTimeout(function () {
      if (!loading) {
        updateShowUserDropDown(false);
      }
    }, 200);
  };
  var firstName = ($userDetails == null ? void 0 : $userDetails.firstName) || DEFAULT_PROFILE_NAME;
  return /*#__PURE__*/react.createElement(LoginTab, {
    onFocus: showDropDown,
    onMouseOver: showDropDown,
    onMouseLeave: hideDropDown,
    "data-id": "user-info-tab"
  }, /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LoginTabWrapper, {
    role: "presentation",
    onClick: function onClick() {
      return handleOnLoginWidgetClick({
        name: 'login',
        componentName: 'header'
      });
    }
  }, !hasMounted || loading ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(CircularShimmer, null), /*#__PURE__*/react.createElement(HorizontalShimmer, null)) : /*#__PURE__*/react.createElement(react.Fragment, null, $userDetails.isLoggedIn ? /*#__PURE__*/react.createElement(LoggedInDetails, {
    isBlackListedUser: isBlackListedUser,
    loading: loading,
    profileImage: $userDetails == null ? void 0 : $userDetails.profileImage,
    firstName: firstName,
    loyaltyMemberTier: loyaltyMemberTier,
    program: program
  }) : /*#__PURE__*/react.createElement(GuestDetails, null), /*#__PURE__*/react.createElement(ArrowIcon, {
    className: "" + (showUserDropDown ? 'up' : 'down')
  }))), showUserDropDown && /*#__PURE__*/react.createElement(UserDropDown, {
    program: program,
    isBlackListedUser: isBlackListedUser,
    isControlledUser: isControlledUser,
    lobName: lobName,
    handleLogout: handleLogout,
    userInfo: $userDetails,
    isLoggedIn: $userDetails.isLoggedIn,
    hideDropDown: function hideDropDown() {
      return updateShowUserDropDown(false);
    },
    memberType: loyaltyMemberTier,
    upcomingTripCount: upComingTripCounts,
    onLoginCtaClick: handleOnLoginWidgetClick,
    navOrigin: navOrigin,
    positionStyle: {
      top: '53px',
      right: '3px'
    }
  })));
};

var _templateObject$3, _templateObject2$1, _templateObject3$1, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var bounce = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-30px);\n  }\n  60% {\n    transform: translateY(-15px);\n  }\n"])));
var HappyLsPop = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n\twidth: 250px;\n\tposition: absolute;\n\ttop: 65px;\n\tright: 10px;\n\tpadding: 15px 10px;\n\tborder-radius: 10px;\n\tbox-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);\n\tbackground-color: #fff;\n\tz-index: 11;\n\tanimation: ", " 2s 2;\n\n\t&::after {\n\t\tbottom: 100%;\n\t\tleft: 90%;\n\t\tborder: solid transparent;\n\t\tcontent: '';\n\t\theight: 0;\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tpointer-events: none;\n\t\tborder-color: rgba(255, 255, 255, 0);\n\t\tborder-bottom-color: #fff;\n\t\tborder-width: 8px;\n\t\tmargin-left: -8px;\n\t}\n"])), bounce);
var LsPopOffer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n\tpadding: 11px 10px;\n\tborder-radius: 8px;\n\tbackground-color: rgba(80, 227, 194, 0.1);\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 7px 0 0;\n"])));
var LsPopOfferIcon = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\tflex-shrink: 0;\n\tmargin-right: 16px;\n\n\timg {\n\t\tmax-width: 100%;\n\t}\n"])));
var LsPopOfferTitle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\tcolor: #268570;\n\tfont-size: 14px;\n\n\t> span:nth-child(1) {\n\t\tvertical-align: middle;\n\t}\n"])));
var LsPopOfferSubtitle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tmargin-top: 3px;\n"])));
var SignUpButton = styled_components_browser_esm/* default.button */.ZP.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 36px;\n\tborder-radius: 8px;\n\tbackground-color: #2276e3;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\t", ";\n\n\t&:hover {\n\t\tcolor: #fff;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);

var LoginSignupPopup = function LoginSignupPopup(_ref) {
  var _persuationsText$sign;
  var onLogin = _ref.onLogin,
    closePopOver = _ref.closePopOver,
    persuationsText = _ref.persuationsText;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    pdt = _useAnalytics.pdt,
    adobe = _useAnalytics.adobe;
  function closePopup(event) {
    if (!event.target.closest('.happy-lsPop')) {
      if (closePopOver) closePopOver();
    }
  }
  (0,react.useEffect)(function () {
    /**
     * this listeners check if popover is shown then if click is outside the popover
     * it closes the popover
     */
    document.addEventListener('click', closePopup);
    pdt.track('growth_non_int_HEADER_POPOVER_LOGIN_VISIBLES');
    return function () {
      document.removeEventListener('click', closePopup);
    };
  }, []);
  var handleCtaClick = function handleCtaClick() {
    pdt.track('growth_int_HEADER_POPOVER_CTA_CLICK');
    adobe.track('ctaClick', {
      cta: {
        name: "Login Popover",
        type: 'itemClick',
        componentName: 'Login Popover',
        destination: 'Login Popup'
      }
    });
    onLogin();
  };
  return /*#__PURE__*/react.createElement(HappyLsPop, {
    "data-id": "header-popover"
  }, /*#__PURE__*/react.createElement(SignUpButton, {
    onClick: handleCtaClick,
    type: "button"
  }, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "BaseW2"
  }, persuationsText == null || (_persuationsText$sign = persuationsText.signUp) == null ? void 0 : _persuationsText$sign.ctaText)), /*#__PURE__*/react.createElement(LsPopOffer, null, /*#__PURE__*/react.createElement(LsPopOfferIcon, null, /*#__PURE__*/react.createElement("img", {
    src: "https://gos3.ibcdn.com/login-gift-1607962961.png",
    alt: "Offer"
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(LsPopOfferTitle, null, /*#__PURE__*/react.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: persuationsText == null ? void 0 : persuationsText.title
    }
  })), /*#__PURE__*/react.createElement(LsPopOfferSubtitle, null, persuationsText == null ? void 0 : persuationsText.subTitle))));
};

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ErrorBoundary, _Component);
  function ErrorBoundary(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  };
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // console.log('Error', error, errorInfo)
  };
  _proto.render = function render() {
    var hasError = this.state.hasError;
    var children = this.props.children;
    if (hasError) {
      // You can render any custom fallback UI
      return null;
    }
    return children;
  };
  return ErrorBoundary;
}(react.Component);

var _templateObject$2, _templateObject2, _templateObject3;
var HappyGiHeader = styled_components_browser_esm/* default.header */.ZP.header(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tbackground: #fff;\n\tdisplay: flex !important;\n\talign-items: center;\n\tbox-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n\tz-index: 900;\n\tposition: relative;\n\theight: 64px;\n\n\t&.header-sticky {\n\t\tposition: fixed !important;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n\n\t@media (max-width: 640px) {\n\t\tdisplay: none !important;\n\t}\n"])));
var LoginWidgetWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: auto;\n\tposition: relative;\n"])));
var HeaderWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\twidth: 1200px;\n    margin: 0px auto;\n    display: flex;\n"])));

var hasTimeExpired = function hasTimeExpired(expDate) {
  var xDate = new Date(expDate);
  if (!Number.isNaN(xDate.getDate())) {
    var cDate = new Date();
    if (cDate > xDate) return true;
    return false;
  }
  return false;
};
var useFestivalTheme = function useFestivalTheme(_ref) {
  var headerLogoRef = _ref.headerLogoRef;
  var _useConfigStore = useConfigStore(function (s) {
      return s;
    }),
    configStoreData = _useConfigStore.data,
    configStoreDataLoaded = _useConfigStore.loaded;
  (0,react.useEffect)(function () {
    var _configStoreData$COMM, _configData$data;
    var configData = configStoreData == null || (_configStoreData$COMM = configStoreData.COMMON) == null ? void 0 : _configStoreData$COMM[growth_gi_dweb_auth_esm/* CONFIG_KEY_DWEB_AUTH */.z];
    if (configData && configStoreDataLoaded && configData != null && (_configData$data = configData.data) != null && _configData$data.festivalTheme) {
      var _themes$date;
      var themes = configData.data.festivalTheme;
      // we keep expire date for special theme.
      // check if theme is still valid for today
      // date format: MM/DD/YYYY
      var expireTime = themes == null || (_themes$date = themes.date) == null ? void 0 : _themes$date.expire;
      if (expireTime && hasTimeExpired(expireTime)) return;

      // apply special theme to dom direclty, to avoid rerender

      // goibibo image
      if (themes != null && themes.gi_logo && headerLogoRef.current) {
        var giLogoElm = headerLogoRef.current;
        giLogoElm.style.backgroundImage = "url(" + themes.gi_logo + ")";
        giLogoElm.classList.remove('header-sprite', 'logo', 'gi-logo');
        giLogoElm.classList.add('special-logo');
      }
    }
  }, [configStoreData, configStoreDataLoaded, headerLogoRef]);
};

var LOGIN_POPOVER_TIMEOUT = 10000; // 10sec

var useLoginPopover = function useLoginPopover(_ref) {
  var _configStoreData$COMM;
  var loginPersuation = _ref.loginPersuation,
    loginPersuationTimeout = _ref.loginPersuationTimeout,
    sticky = _ref.sticky,
    lobName = _ref.lobName;
  var _useConfigStore = useConfigStore(function (s) {
      return s;
    }),
    configStoreData = _useConfigStore.data,
    configStoreDataLoaded = _useConfigStore.loaded;
  var configData = configStoreData == null || (_configStoreData$COMM = configStoreData.COMMON) == null ? void 0 : _configStoreData$COMM[growth_gi_dweb_auth_esm/* CONFIG_KEY_DWEB_AUTH */.z];
  var _useState = (0,react.useState)(false),
    show = _useState[0],
    setShowLoginPopover = _useState[1];
  var popoverTimerTimeout = (0,react.useRef)(0);
  var closeLogInPopover = function closeLogInPopover() {
    setShowLoginPopover(false);
  };
  var setLoginPopoverTimer = function setLoginPopoverTimer(time) {
    if (popoverTimerTimeout.current) {
      // Exception?
      return;
    }
    // Remember the timer handle
    popoverTimerTimeout.current = setTimeout(function () {
      closeLogInPopover();
    }, time);
  };
  var showLoginPopOver = function showLoginPopOver(persuationsText) {
    setShowLoginPopover(persuationsText);
    var timeout = loginPersuationTimeout || LOGIN_POPOVER_TIMEOUT;
    setLoginPopoverTimer(timeout);
  };
  var clearLoginPopoverTimer = function clearLoginPopoverTimer() {
    // Is our timer running?
    if (popoverTimerTimeout.current) {
      // Yes, clear it
      clearTimeout(popoverTimerTimeout.current);
    }
  };
  var setLoginPopoverVisiblity = (0,react.useCallback)(function () {
    var _configData$data, _configData$data2;
    if (configData && configStoreDataLoaded && configData != null && (_configData$data = configData.data) != null && _configData$data.loginPopover && configData != null && (_configData$data2 = configData.data) != null && _configData$data2.bookingOffers) {
      var _configData$data3 = configData.data,
        _configData$data3$boo = _configData$data3.bookingOffers,
        bookingOffers = _configData$data3$boo === void 0 ? {} : _configData$data3$boo,
        _configData$data3$log = _configData$data3.loginPopover,
        loginPopover = _configData$data3$log === void 0 ? {} : _configData$data3$log;

      // lob wise offers text comes from api, select only offer that need to
      // display on current lob
      var persuationsText = _extends({}, bookingOffers == null ? void 0 : bookingOffers[lobName], loginPopover);
      if (loginPersuation) {
        var _persuationsText$sign;
        var mandatoryTextToDisplayUI = (persuationsText == null ? void 0 : persuationsText.title) && (persuationsText == null ? void 0 : persuationsText.subTitle) && (persuationsText == null || (_persuationsText$sign = persuationsText.signUp) == null ? void 0 : _persuationsText$sign.ctaText);
        if (!(0,growth_auth_helpers_esm/* isUserTokenPresent */.Tq)() && mandatoryTextToDisplayUI) {
          showLoginPopOver(persuationsText);
        } else {
          closeLogInPopover();
        }
      }
    }
  }, [configStoreDataLoaded, lobName, loginPersuation, sticky]);
  (0,react.useEffect)(function () {
    /**
     * on load don't show login popover in "non sticky" header. It does not fit when user scrolls
     * the page when popover is visible in header
     *
     * NOTE: we allow to show popover for no sticky header also via 'SHOW_LOGIN_POP_OVER' dom event
     */
    if (sticky) {
      setLoginPopoverVisiblity();
    }
    return function () {
      clearLoginPopoverTimer();
    };
  }, [setLoginPopoverVisiblity]);
  (0,react.useEffect)(function () {
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER, setLoginPopoverVisiblity);
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER, closeLogInPopover);
    return function () {
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER, setLoginPopoverVisiblity);
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER, closeLogInPopover);
    };
  }, [setLoginPopoverVisiblity]);
  return {
    closeLogInPopover: closeLogInPopover,
    show: show
  };
};

var Header$1 = function Header(props) {
  var handleOnLoginModalOpen = props.handleOnLoginModalOpen,
    onLogoutSuccess = props.onLogoutSuccess,
    sticky = props.sticky,
    lobName = props.lobName,
    reloadAfterLogout = props.reloadAfterLogout,
    _props$loginPersuatio = props.loginPersuation,
    loginPersuation = _props$loginPersuatio === void 0 ? true : _props$loginPersuatio,
    loginPersuationTimeout = props.loginPersuationTimeout,
    headerStyle = props.headerStyle,
    _props$navOrigin = props.navOrigin,
    navOrigin = _props$navOrigin === void 0 ? '' : _props$navOrigin;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
    _useAnalytics.pdt;
  var isLoggedIn = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
    return s.data.isLoggedIn;
  });
  var bookingSummaryState = (0,growth_data_store_esm/* useBookingSummaryStore */.tQ)(function (s) {
    return s;
  });
  var upComingTripCounts = (0,growth_data_store_esm/* selectUpcomingBookingsCount */.y7)(bookingSummaryState);
  var headerLogoRef = (0,react.useRef)(null);
  var headerLeftThemeRef = (0,react.useRef)(null);

  /**
   * For any special occasions we change gi logo and few theme images.
   * we get this images from api, right now and apply in client side.
   */
  useFestivalTheme({
    headerLogoRef: headerLogoRef
  });
  var _useLoginPopover = useLoginPopover({
      loginPersuation: loginPersuation,
      loginPersuationTimeout: loginPersuationTimeout,
      sticky: sticky,
      lobName: lobName
    }),
    loginPopover = _useLoginPopover.show,
    closeLogInPopover = _useLoginPopover.closeLogInPopover;
  function popoverLoginHandler() {
    // pdt.track('HAPPY_HEADER_WEBA__CLICK_POPOVER_LOGIN_BTN');
    handleOnLoginModalOpen();
  }
  var giLogoClickTargetUrl = navOrigin + lobsPathName.HOME;
  return /*#__PURE__*/react.createElement(HappyGiHeader, {
    ref: headerLeftThemeRef,
    "data-id": "dweb-header-root",
    className: sticky ? 'header-sticky' : 'header-sticky-nope',
    style: headerStyle
  }, /*#__PURE__*/react.createElement(HeaderWrapper, null, /*#__PURE__*/react.createElement(HeaderLogo, {
    homeURL: giLogoClickTargetUrl,
    ref: headerLogoRef,
    lobName: lobName
  }), /*#__PURE__*/react.createElement(NavBar, {
    navList: lobsNavList(navOrigin),
    lobName: lobName
  }), ' ', /*#__PURE__*/react.createElement(LoginWidgetWrapper, null, /*#__PURE__*/react.createElement(NavWidgets, {
    isLoggedIn: isLoggedIn || false,
    upcomingTrip: upComingTripCounts,
    navOrigin: navOrigin,
    lobName: lobName
  }), /*#__PURE__*/react.createElement(ErrorBoundary, null, /*#__PURE__*/react.createElement(UserLoginWidget, {
    lobName: lobName,
    onLogoutSuccess: onLogoutSuccess,
    showLogin: handleOnLoginModalOpen,
    reloadAfterLogout: reloadAfterLogout,
    isLoginPopoverVisible: loginPopover,
    navOrigin: navOrigin,
    upComingTripCounts: upComingTripCounts
  })), loginPopover && /*#__PURE__*/react.createElement(LoginSignupPopup, {
    closePopOver: function closePopOver() {
      return closeLogInPopover();
    },
    onLogin: function onLogin() {
      return popoverLoginHandler();
    },
    persuationsText: loginPopover
  }))));
};

var AuthFlowModal = function AuthFlowModal(props) {
  var onLoginClose = props.onLoginClose,
    onLoginSuccess = props.onLoginSuccess,
    lobName = props.lobName,
    modalStyle = props.modalStyle,
    shouldShowCloseButton = props.shouldShowCloseButton,
    allowInternationalLogin = props.allowInternationalLogin;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    pdt = _useAnalytics.pdt,
    adobe = _useAnalytics.adobe;
  var configData = useConfigStore(function (s) {
    return s.data;
  });
  var handleModalClose = function handleModalClose() {
    onLoginClose();
  };
  (0,react.useEffect)(function () {
    pdt.track('HAPPY_AUTH_WEBA__UX_LOGIN_DIALOG_OPEN', {
      ab_experiment: 'happy-auth'
    });
    adobe.track('Login_Popup_Load');
  }, []);
  return /*#__PURE__*/react.createElement(growth_modal_esm/* Modal */.u, {
    rootStyle: _extends({
      background: 'transparent'
    }, modalStyle)
    /** dweb-auth have a close button, hide the close button of modal */,
    closeBtnStyle: {
      display: 'none'
    },
    onClose: handleModalClose,
    shouldCloseOutSideClick: shouldShowCloseButton !== false
  }, /*#__PURE__*/react.createElement(growth_gi_dweb_auth_esm/* default */.Z, {
    onClose: handleModalClose,
    lobName: lobName,
    onLoginSuccess: onLoginSuccess,
    showCloseButton: shouldShowCloseButton,
    configData: configData,
    prefillMobileNumber: undefined,
    allowInternationalLogin: allowInternationalLogin
  }));
};

var _templateObject$1;
var HeaderContainer$1 = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\tdisplay: block;\n\theight: 64px;\n\twidth: 100%;\n"])));

var HeaderContainer = function HeaderContainer(props) {
  var onLoginSuccess = props.onLoginSuccess,
    lobName = props.lobName,
    onLogoutSuccess = props.onLogoutSuccess,
    sticky = props.sticky,
    reloadAfterLogout = props.reloadAfterLogout,
    loginPersuation = props.loginPersuation,
    loginPersuationTimeout = props.loginPersuationTimeout,
    hideHeader = props.hideHeader,
    headerStyle = props.headerStyle,
    modalStyle = props.modalStyle,
    shouldShowCloseButton = props.shouldShowCloseButton,
    navOrigin = props.navOrigin,
    allowInternationalLogin = props.allowInternationalLogin;
  var _useState = (0,react.useState)(false),
    loginModal = _useState[0],
    toggleLoginModal = _useState[1];
  var fetchProfileDetails = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchBookingSummary = (0,growth_data_store_esm/* useBookingSummaryStore */.tQ)(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchLoyaltyInfo = (0,growth_data_store_esm/* useLoyaltyUserInfoStore */.yL)(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchGocash = (0,growth_data_store_esm/* useGoCashBalanceStore */.JK)(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
    _useAnalytics.pdt;
  var onProfileDetailsError = function onProfileDetailsError(err) {
    if ((err == null ? void 0 : err.status) === 404) {
      (0,growth_auth_helpers_esm/* clearUserTokens */.H)();
      growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT);
    }
  };
  var fetchAllHeaderData = (0,react.useCallback)(function () {
    var token = (0,growth_auth_helpers_esm/* isUserTokenPresent */.Tq)();
    if (token) {
      var userDetail = fetchProfileDetails({
        platform: 'dweb',
        onError: onProfileDetailsError
      });
      Promise.all([fetchLoyaltyInfo(), fetchBookingSummary(), fetchGocash()]);
      return userDetail;
    }
    return Promise.resolve({});
  }, []);

  // close the login modal
  var handleOnLoginModalClose = (0,react.useCallback)(function () {
    toggleLoginModal(function () {
      return false;
    });
  }, []);

  // open the login modal
  var handleOnLoginModalOpen = (0,react.useCallback)(function () {
    toggleLoginModal(function () {
      return true;
    });
  }, []);
  var handleOnLoginSuccess = (0,react.useCallback)(function () {
    if (onLoginSuccess) onLoginSuccess();
    fetchAllHeaderData();
  }, [onLoginSuccess, fetchAllHeaderData]);
  (0,react.useEffect)(function () {
    /** allow refresh the header data from outside
     * usecases:
     * - when new profile image or details are updated in profile page by user we would want to see the
     *   updated info in header as well
     * - when logout happens from somewhere outside the header, we would refresh the data again
     */
    // put all global Header/Auth event listners here.
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.REFRESH_HEADER_DATA, function () {
      fetchAllHeaderData();
    });
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.START_LOGIN_FLOW, handleOnLoginModalOpen);
    return function () {
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.REFRESH_HEADER_DATA, function () {
        fetchAllHeaderData();
      });
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.START_LOGIN_FLOW, handleOnLoginModalOpen);
    };
  }, []);
  (0,react.useEffect)(function () {
    // hydrate store with require data and trigger load events
    function loadInitialData() {
      return _loadInitialData.apply(this, arguments);
    }
    function _loadInitialData() {
      _loadInitialData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              (0,growth_pdt_push_esm/* pdtPush */.g)('dWeb_header_loaded', {
                event_detail: {
                  components: [{
                    content_details: [{
                      content_id: 'dWeb_header_loaded',
                      content_category_name: 'itemLoaded'
                    }]
                  }]
                }
              });
              try {
                fetchAllHeaderData();
              } catch (e) {
                // pdt.setUserVars({
                // 	user: {
                // 		uuid: 'error',
                // 	},
                // 	lob: lobName,
                // });
                // pdt.track('HEADER_LOADED', {
                // 	item_position: sticky ? 'sticky' : 'scroll',
                // });
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _loadInitialData.apply(this, arguments);
    }
    loadInitialData();
  }, []);
  return /*#__PURE__*/react.createElement(react.Fragment, null, !hideHeader && /*#__PURE__*/react.createElement(HeaderContainer$1, null, /*#__PURE__*/react.createElement(Header$1, {
    handleOnLoginModalOpen: handleOnLoginModalOpen,
    lobName: lobName,
    loginPersuation: loginPersuation,
    loginPersuationTimeout: loginPersuationTimeout,
    onLogoutSuccess: onLogoutSuccess,
    sticky: sticky,
    reloadAfterLogout: reloadAfterLogout,
    headerStyle: headerStyle,
    navOrigin: navOrigin
  })), loginModal && /*#__PURE__*/react.createElement(AuthFlowModal, {
    shouldShowCloseButton: shouldShowCloseButton,
    lobName: lobName,
    onLoginSuccess: handleOnLoginSuccess,
    onLoginClose: handleOnLoginModalClose,
    modalStyle: modalStyle,
    allowInternationalLogin: allowInternationalLogin
  }));
};

var _templateObject;
var Style = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\t.header-sprite,\n\t.dropdown-sprite {\n\t\tbackground: url(https://go-assets.ibcdn.com/u/GI/images/1736403968363-header-sprite.png) 0 0 no-repeat;\n\t\tbackground-size: 125px 200px;\n\t\tdisplay: block;\n\t\tflex-shrink: 0;\n\t}\n\n\t.header-sprite.logo {\n\t\twidth: 104px;\n\t\theight: 30px;\n\t\tbackground-position: -2px -1px;\n\t}\n\n\t.header-sprite.nav-icon-flights {\n\t\twidth: 32px;\n\t\theight: 20px;\n\t\tbackground-position: -69px -33px;\n\t}\n\n\t.header-sprite.nav-icon-hotels {\n\t\twidth: 24px;\n\t\theight: 22px;\n\t\tbackground-position: -3px -178px;\n\t}\n\n\t.header-sprite.nav-icon-bus {\n\t\twidth: 32px;\n\t\theight: 14px;\n\t\tbackground-position: -3px -89px;\n\t}\n\n\t.header-sprite.nav-icon-trains {\n\t\twidth: 36px;\n\t\theight: 16px;\n\t\tbackground-position: -2px -52px;\n\t}\n\n\t.header-sprite.nav-icon-cabs {\n\t\twidth: 34px;\n\t\theight: 16px;\n\t\tbackground-position: -2px -69px;\n\t}\n\n\t.header-sprite.nav-icon-holiday {\n\t\twidth: 26px;\n\t\theight: 21px;\n\t\tbackground-position: -4px -105px;\n\t}\n\n\t.header-sprite.nav-icon-forex {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tbackground-position: -5px -131px;\n\t}\n\n\t.header-sprite.nav-icon-insurance {\n\t\twidth: 20px;\n\t\theight: 22px;\n\t\tbackground-position: -5px -153px;\n\t}\n\n\t.header-sprite.user-icon {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tbackground-position: -41px -56px;\n\t}\n\n\t.header-sprite.mytrip-icon {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tbackground-position: -43px -33px;\n\t}\n\t/* -- DropDown Icons sprites -- */\n\t.dropdown-sprite.gotribeLogo {\n\t\twidth: 50px;\n\t\theight: 14px;\n\t\tbackground-position: -38px -86px;\n\t}\n\t.dropdown-sprite.gotribe {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -2px -33px;\n\t}\n\t.dropdown-sprite.offers {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -107px -19px;\n\t}\n\t.dropdown-sprite.mytrip {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -107px -1px;\n\t}\n\t.dropdown-sprite.gocash {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -22px -33px;\n\t}\n\t.dropdown-sprite.student {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -107px -37px;\n\t}\n\t.dropdown-sprite.giftCard {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -107px -57px;\n\t}\n\t/* -- CSS Icons -- */\n\t.arrow-icon {\n\t\tborder: solid #2274e0;\n\t\tborder-width: 0 2px 2px 0;\n\t\tdisplay: inline-block;\n\t\tpadding: 2px;\n\t\tmargin-left: auto;\n\t}\n\n\t.arrow-icon.right {\n\t\ttransform: rotate(-45deg);\n\t\t-webkit-transform: rotate(-45deg);\n\t}\n\n\t.arrow-icon.left {\n\t\ttransform: rotate(135deg);\n\t\t-webkit-transform: rotate(135deg);\n\t}\n\n\t.arrow-icon.up {\n\t\ttransform: rotate(-135deg);\n\t\t-webkit-transform: rotate(-135deg);\n\t}\n\n\t.arrow-icon.down {\n\t\ttransform: rotate(45deg);\n\t\t-webkit-transform: rotate(45deg);\n\t}\n"])));

var RootHoc = function RootHoc(Component) {
  var WithHOC = function WithHOC(props) {
    var headerEnv = props.headerEnv,
      lobName = props.lobName,
      adobeLobName = props.adobeLobName,
      configData = props.configData;

    /** Memorize b/c we don't want to call the setData again if there in no change in configData */
    (0,react.useMemo)(function () {
      if (configData) (0,growth_config_store_browser_esm/* setData */.a_)(useConfigStore, configData);
    }, [configData]);
    var fetchConfigStoreData = useConfigStore(function (s) {
      return s.fetch;
    }, shallow/* shallow */.X);
    (0,react.useEffect)(function () {
      var _configData$COMMON, _configData$COMMON2;
      var initializeConfigData = configData;
      if (typeof (configData == null || (_configData$COMMON = configData.COMMON) == null ? void 0 : _configData$COMMON[DWEB_HEADER_COUNTRY_LIST_CONFIG]) === "undefined" || typeof (configData == null || (_configData$COMMON2 = configData.COMMON) == null ? void 0 : _configData$COMMON2[DWEB_HEADER_CONFIG]) === "undefined") {
        initializeConfigData = undefined;
      }
      fetchConfigStoreData({
        keys: [DWEB_HEADER_CONFIG, DWEB_HEADER_COUNTRY_LIST_CONFIG],
        lobs: 'COMMON',
        cacheOpts: {
          ttl: 15 // min
        },

        initData: initializeConfigData
      });
    }, [configData]);
    // Analytics plugin initialization
    var pdtInstance = {};
    var adobeInstance = {};
    if (growth_ssr_utils_esm/* isOnClient */.BK) {
      var _window$adobeDataLaye, _window$adobeDataLaye2;
      pdtInstance = new growth_web_analytics_esm/* default */.Z();
      adobeInstance = new growth_web_analytics_esm/* default */.Z();
      pdtInstance.initialize({
        plugin: (0,growth_analytics_plugin_pdt_esm/* default */.Z)({
          debug: false
        }),
        globalProperties: {
          context: {
            environment: headerEnv || 'error'
          },
          eventProperties: {
            lob: lobName
          }
        },
        debug: false
      });
      var pageInfo = (_window$adobeDataLaye = window.adobeDataLayer) == null || _window$adobeDataLaye.getState == null ? void 0 : _window$adobeDataLaye.getState('page.pageInfo');
      var accountInfo = (_window$adobeDataLaye2 = window.adobeDataLayer) == null || _window$adobeDataLaye2.getState == null ? void 0 : _window$adobeDataLaye2.getState('account.accountInfo');
      adobeInstance.initialize({
        plugin: (0,growth_analytics_plugin_adobe_esm/* default */.Z)({
          page: {
            pageInfo: _extends({}, pageInfo, {
              lob: adobeLobName || lobName
            })
          },
          account: {
            accountInfo: _extends({}, accountInfo, {
              website: 'goibibo'
            })
          }
        }, false),
        debug: false
      });
    }
    return /*#__PURE__*/react.createElement(Style, null, /*#__PURE__*/react.createElement(growth_use_analytics_esm/* AnalyticsContextProvider */.nx, {
      pdtInstance: pdtInstance,
      adobeInstance: adobeInstance
    }, /*#__PURE__*/react.createElement(Component, props)));
  };
  return WithHOC;
};

var HeaderComponent = function HeaderComponent(_ref) {
  var onLoginSuccess = _ref.onLoginSuccess,
    sticky = _ref.sticky,
    onLogoutSuccess = _ref.onLogoutSuccess,
    lobName = _ref.lobName,
    reloadAfterLogout = _ref.reloadAfterLogout,
    headerEnv = _ref.headerEnv,
    loginPersuation = _ref.loginPersuation,
    loginPersuationTimeout = _ref.loginPersuationTimeout,
    hideHeader = _ref.hideHeader,
    headerStyle = _ref.headerStyle,
    modalStyle = _ref.modalStyle,
    shouldShowCloseButton = _ref.shouldShowCloseButton,
    adobeLobName = _ref.adobeLobName,
    navOrigin = _ref.navOrigin,
    configData = _ref.configData,
    allowInternationalLogin = _ref.allowInternationalLogin;
  return /*#__PURE__*/react.createElement(HeaderContainer, {
    headerEnv: headerEnv,
    adobeLobName: adobeLobName,
    sticky: sticky,
    lobName: lobName,
    hideHeader: hideHeader,
    loginPersuation: loginPersuation,
    loginPersuationTimeout: loginPersuationTimeout,
    onLoginSuccess: onLoginSuccess,
    onLogoutSuccess: onLogoutSuccess,
    reloadAfterLogout: reloadAfterLogout,
    headerStyle: headerStyle,
    modalStyle: modalStyle,
    shouldShowCloseButton: shouldShowCloseButton,
    configData: configData,
    navOrigin: navOrigin,
    allowInternationalLogin: allowInternationalLogin
  });
};
var Header = RootHoc(HeaderComponent);

var showLoginPopOverEvent = function showLoginPopOverEvent() {
  return eventEmitter.emit(DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER);
};
var hideLoginPopOverEvent = function hideLoginPopOverEvent() {
  return eventEmitter.emit(DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER);
};




/***/ })

}]);